import { Rollback } from 'grids/rollback/rollback';
import { GridContainer } from 'libs/ui';

export const RollbackWrapper = (props) => {
  return (
    <GridContainer>
      <Rollback {...props} />
    </GridContainer>
  );
};

export default RollbackWrapper;
